<template>
    <base-order  id="order_normal" name="Encomenda Normal" endpoint="/api/orders/normal" :model="model" :schema="schema" :headers="headers" :advanced_filters="advanced_filters" :account-blocked-message="accountBlockedMessage"></base-order>
</template>

<script>
import MainLayout from './../../Layouts/MainLayout';

export default {
    layout: MainLayout,

    props: {
        model: [Object, Array],
        schema: [Object, Array],
        headers: [Object, Array],
        advanced_filters: Array,

        accountBlockedMessage: String,
    },
    mounted(){
       this.checkHeaders();
       //console.log('width',window.innerWidth);
    },
    methods:{
        checkHeaders(){
            let windowWidth = window.innerWidth;
            if (windowWidth <= 1024) {
                //console.log('IN', this.headers)
                _.each(this.headers,(o)=>{
                    if(o.value=='designation'){
                        o.width='230px'
                    }
                    if(o.value=='quantity'){
                        o.width='150px'
                    }
                    if(o.value=='bonus'){
                        o.width='150px'
                    }
                })
            }
        },
    }
};
</script>
